import EventCreate from 'components/events/EventCreate'
import React from 'react'

function EventCreatePage() {
  return <EventCreate />
}

export default EventCreatePage
